import { isEmpty, once } from 'lodash';
import { saveAs } from 'file-saver';
import { fetch } from '@utils/utils';

import * as storage from '@inqool/uas-web-core/es/utils/storage';

const redirect = (url: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.click();
};

export const Actions = {
  TEST_ACTION: 'TEST_ACTION',
  BREADCRUMBS: 'BREADCRUMBS'
};

export const testAction = (id: string) => {
  return {
    type: Actions.TEST_ACTION,
    payload: { id }
  };
};

const renewAction = async () => {
  const token = storage.get('token');
  if (isEmpty(token) || token === 'null') {
    return;
  }

  try {
    const response = await fetch('/metropolis/api/keepalive', { method: 'GET' });
    if (!response.ok) {
      storage.remove('token');
      redirect('/login');
    }
  } catch (e) {
    storage.remove('token');
    redirect('/login');
  }
};

export const renewToken = once(() => {
  renewAction();
  setInterval(renewAction, 60 * 1000); // 60 s interval refresh
});

export const downloadFile = async (id: string, fileName: string): Promise<boolean> => {
  try {
    const response = await fetch(`/metropolis/api/files/${id}`);

    if (response.ok) {
      const blob = await response.blob();
      saveAs(blob, fileName);
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/actions.ts